import { type CSSProperties } from 'react';

import styles from './loader.module.scss';

interface LoaderProps {
  size?: number;
}

export default function Loader(props: LoaderProps) {
  const { size = 10 } = props;

  const style: CSSProperties = {
    height: `${String(size)}px`,
    width: `${String(size)}px`,
  };

  return (
    <div className={styles.loader}>
      <div style={style} className={styles.loader_item}>
        <div className={styles.loader_itemBubble} />
      </div>
      <div style={style} className={styles.loader_item}>
        <div className={styles.loader_itemBubble} />
      </div>
      <div style={style} className={styles.loader_item}>
        <div className={styles.loader_itemBubble} />
      </div>
    </div>
  );
}
